<template>
    <ToastComponent ref="toast" />
    <template v-if="escondido">
        <input type="password" @keyup.enter="loginEscondido" v-model="passEscondidoInputValue" />
    </template>
    <template v-else>
        <MainScreenComponent @show-toast="showToast" @logout="handleLogout" 
            :profilePicture="user.profilePicture" :email="user.email" :name="user.name" 
            :subscription="user.subscription" :permissions="user.permissions" />
    </template>
</template>

<script>
import MainScreenComponent from '../components/MainScreenComponent.vue';
import ToastComponent from '@/components/ToastComponent.vue';
import { ESCONDIDO } from './router';
import { useAuth } from '@/composables/useAuth';

export default {
    name: 'MainView',
    components: {
        MainScreenComponent,
        ToastComponent
    },
    setup() {
        const { user, logout } = useAuth();
        return { user, logout };
    },
    data() {
        return {
            escondido: ESCONDIDO,
            passEscondidoInputValue: '',
            passEscondido: 'piropelli'
        };
    },
    methods: {
        async handleLogout() {
            await this.logout(this.$router, this.showToast);
        },
        loginEscondido() {
            if (this.passEscondidoInputValue === this.passEscondido) {
                this.escondido = false;
            }
        },
        showToast(message, type) {
            this.$refs.toast.showToast(message, type);
        }
    }
};
</script>
